<template>
  <div>
    <!-- 弹窗选择店铺 -->
    <h-dialog
      :title="$t('common.selectShop')"
      width="800px"
      v-model="choosePointDialog"
      :confirm-loading="confirmLoading"
      @onOk="ok"
      @onCancel="cancel"
      top="3vh"
    >
      <h-table
        ref="choosePointTableRef"
        :http="getList"
        :columns="columns"
        :query-form="queryForm"
        :show-reset="false"
        :show-query="false"
        vuex-namespace="choosePointTable"
        row-key="id"
        :autoRequest="false"
        @result="getResult"
        @selection-change="handleSelectionChange"
      >
        <template #org_id>
          <choose-org-btn v-model="orgId" @change="handleOrgIdChange" />
        </template>
      </h-table>
    </h-dialog>
    <!-- 店铺选择表单 -->
    <div style="display: flex;flex-wrap: wrap">
      <el-radio-group v-model="shop_range">
        <el-radio :value="mapValue.allShop" @click="choosePointFn(mapValue.allShop)">{{ $t('productModules.priceManagement.allStores') }}</el-radio>
        <el-radio :value="mapValue.partShop" @click="choosePointFn(mapValue.partShop)">{{ $t('productModules.priceManagement.someStores') }}</el-radio>
        <!-- 商品模块 统一调价需要部分组织选项 -->
        <el-radio :value="mapValue.partOrg" @click="choosePointFn(mapValue.partOrg)" v-if="allow_choice_org">{{ $t('productModules.priceManagement.partial Organization') }}
        </el-radio>
      </el-radio-group>
      <!-- <div class="h-box" style="margin-left: 20px" v-if="showUploadFile">
        <input type="file" ref="fileInputRef" style="display: none" @change="handleFileChange" />
        <el-button style="color: #00AAA6" @click="handleFileUpload" :loading="fileLoading">+ 上传文件</el-button>
        <span class="hint">支持上传.csv、.xlsx</span>
        <h-link type="primary" @click="downloadFn">下载模版</h-link>
      </div> -->
    </div>
    <div style="display: flex; margin-top: 10px" v-if="shop_range === mapValue.partShop">
      <el-button type="primary" @click="choosePointFn(mapValue.partShop)">{{ $t('common.add') }}</el-button>
      <el-button @click="deleteAllFn" :disabled="!selectedGoods.length">{{ $t('productModules.priceManagement.deleteAll') }}</el-button>
    </div>
    <div class="h-box h-box-org" style="transform: translateX(-84px)" v-if="shop_range === mapValue.partOrg">
      <span class="flex-self-align-start" style="color: #606266">
        <i style="color: #fe223b; margin-right: 4px">*</i>{{ $t('productModules.priceManagement.selectOrganization') }}：
      </span>
      <el-tree
        class="tree"
        ref="treeRef"
        :props="defaultProps"
        show-checkbox
        node-key="id"
        check-on-click-node
        :data="orgList"
        :default-expanded-keys="defaultCheckedKeys"
        @check-change="handleNodeClick"
      />
    </div>
    <!-- 已选择的店铺列表 -->
    <div class="selected-goods-list" v-bind="customAttrs"
         v-if="shop_range === mapValue.partShop && selectedGoods.length">
      <h-simple-table
        ref="multipleTableRef"
        :columns="hasColumns()"
        :dataSource="selectedGoods"
        row-key="id"
        :pagination="pagination"
        wrapper
      >
        <template #operation="{ row }">
          <h-link type="danger" @click="handleDelete(row)" :disabled="isDetail">{{ $t('common.delete') }}</h-link>
        </template>
      </h-simple-table>
    </div>
  </div>
</template>

<script setup>
import { nextTick, onMounted, reactive, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { shopImportApi, shopListApi } from '@/api/marketing/activities-management'
import { columns, hasColumns, queryForm } from './constants'
import { getTreeList } from '@/api/common'
import { $t } from '@/i18n'
queryForm.formItems.forEach(item => { item.label = $t(`${item.label}`); item.placeholder = $t(`${item.placeholder}`) })
const pagination = {
  layout: 'prev, pager, next',
  pageSize: 5,
  pagerCount: 5
}

const shop_range = defineModel('shop_range')
const props = defineProps({
  allow_choice_org: {
    //是否允许选择组织
    type: Boolean,
    default: false
  },
  customAttrs: {
    type: Object,
    default: {}
  },
  isDetail: {
    type: Boolean,
    default: false
  },
  mapValue: {
    type: Object,
    default: { allShop: 2, partShop: 1, partOrg: 3 }
  },
  showUploadFile: {
    type: Boolean,
    default: true
  }
})
const emit = defineEmits(['changeShop'])

// 弹窗相关
const choosePointDialog = ref(false)
const choosePointTableRef = ref()
const confirmLoading = ref(false)

// 店铺数据
const temporarySelectedGoods = ref([]) // 临时选中的店铺
const selectedGoods = ref([]) // 最终选中的店铺
//组织数据
const organization = ref([])
//默认展开的节点key
const defaultCheckedKeys = ref([])
// 分页数据
const pageData = reactive({
  page: 1,
  size: 5
})
const fileLoading = ref(false)
// 上传文件
const fileInputRef = ref()
const handleFileUpload = () => {
  fileInputRef.value.click()
}

const handleFileChange = (e) => {
  const file = e.target.files[0]
  const data = new FormData()
  data.append('import_file', file)
  fileLoading.value = true
  shopImportApi(data)
    .then(({ result }) => {
      console.log(result, 'result')
      if (result) {
        shop_range.value = props.mapValue.partShop
        selectedGoods.value = result.data.rows
        emit('changeShop', selectedGoods.value)
        ElMessage.success('导入成功')
        e.target.value = null
      }
    })
    .finally(() => {
      fileLoading.value = false
    })
  e.target.value = null
}
const deleteAllFn = () => {
  selectedGoods.value = []
  emit('changeShop', selectedGoods.value)
}
// 选择店铺类型
const choosePointFn = async (value) => {
  if (isDetail.value) {
    return
  }
  if (value === props.mapValue.partShop) {
    // 先打开弹窗
    choosePointDialog.value = true
    temporarySelectedGoods.value = [] //清空弹窗中临时选中的店铺
    shop_range.value = value

    // 等待下一个事件循环，确保表格已经渲染
    await nextTick()
    choosePointTableRef.value?.refresh(true)
    choosePointTableRef.value?.tableFn('clearSelection')
    // 如果有已选店铺，设置选中状态
    if (selectedGoods.value.length) {
      temporarySelectedGoods.value = selectedGoods.value
      selectedGoods.value.forEach((item) => {
        choosePointTableRef.value?.tableFn('toggleRowSelection', item, true)
      })
    }
  } else if (value === props.mapValue.allShop) {
    shop_range.value = value
    await nextTick()
    // selectedGoods.value = []
    // pageData.total = 0
    emit('changeShop', [])
  } else if (value === props.mapValue.partOrg) {
    await getOrgList()
    treeRef.value.setCheckedKeys(organization.value)
    defaultCheckedKeys.value = organization.value
    emit('changeShop', treeRef.value.getCheckedKeys())
  }
}

// 获取店铺列表
const getList = (params) => {
  params.enabled = 1
  params.bound = 1
  params.org_id = orgId.value
  return shopListApi(params)

}

const orgId = ref()
const handleOrgIdChange = () => {
  choosePointTableRef.value.refresh()
}

// 选择店铺变化
const handleSelectionChange = (selection) => {
  temporarySelectedGoods.value = selection
  // console.log('弹窗选择的店铺', temporarySelectedGoods.value)
}

// 获取查询结果
const getResult = (res) => {
  // console.log('查询结果:', res)
}

// 弹窗操作
const cancel = () => {
  choosePointTableRef.value?.tableFn('clearSelection')
  emit('changeShop', selectedGoods.value)
  choosePointTableRef.value?.reset()

}

const ok = () => {
  // 合并新选中的店铺,去重
  selectedGoods.value = [...temporarySelectedGoods.value]
  emit('changeShop', selectedGoods.value)
  choosePointDialog.value = false
  choosePointTableRef.value?.reset()
}

// 删除已选店铺
const handleDelete = (row) => {
  selectedGoods.value = selectedGoods.value.filter(
    (item) => item.id !== row.id
  )
  emit('changeShop', selectedGoods.value)
}

const isDetail = ref(false)
const showDetailGoods = async (data, disabled) => {
  // console.log("组件接受参数", data, disabled);
  await nextTick()
  if (shop_range.value === props.mapValue.partOrg) {
    treeRef.value.setCheckedKeys(data)
    defaultCheckedKeys.value = data
    organization.value = data
  } else if (shop_range.value === props.mapValue.partShop) {
    selectedGoods.value = data
  } else {
    selectedGoods.value = []
  }
  isDetail.value = disabled
}
const downloadFn = () => {
  const DOWNLOAD_URL =
    'https://hgoboxyz1.hgobox.com/%E5%BA%97%E9%93%BA%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx'
  try {
    window.open(DOWNLOAD_URL, '_blank')
  } catch (error) {
    ElMessage.error('下载链接打开失败，请稍后再试。')
  }
}
const handleNodeClick = (data) => {
  let nodeArr = treeRef.value.getCheckedKeys()
  organization.value = nodeArr
  emit('changeShop', nodeArr)
}
const treeRef = ref()
const defaultProps = {
  label: 'name',
  children: 'org_list'
}
const orgList = ref([])

async function getOrgList() {
  const { result } = await getTreeList()
  if (result) {
    orgList.value = [result.data]
  }
}

defineExpose({
  showDetailGoods
})
onMounted(() => {
  getOrgList()
})
</script>

<style lang="scss" scoped>
.delete-btn {
  color: var(--primary-color);
  cursor: pointer;
}

.selected-goods-list {
  margin-top: 10px;
  max-width: 800px;

  .x-table-page {
    padding: 0;
    margin: 0;
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

:deep(.form-row) {
  max-width: 50% !important;
  flex: 2 !important;
}

.hint {
  margin: 0 12px;
  font-weight: 400;
  font-size: 14px;
  color: #9fa1a3;
}
:deep(.x-form) {
  padding-top: 0 !important;
}
</style>
